import React from 'react';
import { Button } from 'rmwc/Button';
import gtagEvent from '../../utilities/analytics/gtag-event';

import './landing-pages.css';
import '@material/button/dist/mdc.button.min.css';

const heroUri = 'https://storage.googleapis.com/quiver-four.appspot.com/marketing%2Fuploads%2Fblack-favicon-512.png?GoogleAccessId=firebase-adminsdk-z45et@quiver-four.iam.gserviceaccount.com&Expires=2145916800&Signature=Og2ZxWatfvmJ3XHmJCXTw8m20GziWnb4NcTwMU/1syLcRGQqocM4L59cZrfX3%2BB85ioI4yukQYRvjLj3hTr44iJf3I1ugSNCNT/r8v%2B4lr4Pg8IAab4aIkBKwnKnMtD2TFfhp5GwQHezUXQAM5j20PVdqlVy%2BX7ekLUl1G1CngebEq74w%2B%2B6kT0LNLY7ujh2EmYbJ%2BR9cufjONoHYm7di3w3gYqBS2z6Q6lEAE%2Bx1BqffoV1XxhqPCgHv1YUrRyDYzKb%2BzIFy0fMhjkDsVos98aLnBa6n5XJwgZw1LAoW%2B3Gvr78ShV9kt%2BCWjqHHzZaDFxhNMLj3NRDwOnDBO5YDg%3D%3D';

export default props => {
  return (
    <article id="why-calligraphy-dot-org" className="static-landing-page" role="main">
      <section className="centered">
        <div className="row">
          <div className="hide-small">
            <img className="hero" src={heroUri} alt="Why Calligraphy.org?" />
          </div>
          <div className="flex">
            <h1 className="headline-text">Why Calligraphy.org?</h1>
            <p className="primary-text">
              We have plenty of reasons 🤩
            </p>
            <p className="secondary-text">
              <strong>Still have questions?</strong> <br /> Email Melissa at{' '}
              <a href="mailto:melissa@calligraphy.org?subject=Calligraphy.org Questions&body=Hey Melissa,">
                melissa@calligraphy.org
              </a>. She'd love to hear from you.
            </p>
            <a href="https://store.calligraphy.org/">
              <Button
                className="cta-button"
                raised
                onClick={() => gtagEvent('cta-click', { page: 'why-calligraphy-dot-org', position: 'primary' })}
              >
                Get started today
              </Button>
            </a>
          </div>
        </div>
      </section>
    </article>
  );
};
